import {
    safeLocalGet,
    safeLocalRemove,
    safeLocalSet,
} from "@wags/tanstack-start/browser";
import {
    isDeclinable,
    isQuickReplyKey,
    QUICK_REPLY_KEYS,
    type QuickReplyKey,
} from "./quick-replies";

const KEY = "wags_declined_asks";
const ANSWERED_KEY = "wags_answered_asks";

function readList(storageKey: string): QuickReplyKey[] {
    const raw = safeLocalGet(storageKey);
    if (!raw) return [];
    try {
        const parsed = JSON.parse(raw);

        return Array.isArray(parsed)
            ? parsed.filter(
                  (ask): ask is QuickReplyKey =>
                      typeof ask === "string" && isQuickReplyKey(ask),
              )
            : [];
    } catch {
        return [];
    }
}

function write(storageKey: string, asks: QuickReplyKey[]): void {
    if (asks.length === 0) {
        safeLocalRemove(storageKey);
        return;
    }
    safeLocalSet(storageKey, JSON.stringify(asks));
}

export function declinedAsks(): QuickReplyKey[] {
    return readList(KEY);
}

export function noteAskDeclined(ask: QuickReplyKey): void {
    const asks = readList(KEY);
    if (!asks.includes(ask)) write(KEY, [...asks, ask]);
}

export function noteAskAnswered(ask: QuickReplyKey): void {
    const declined = readList(KEY);
    if (declined.includes(ask)) {
        write(
            KEY,
            declined.filter((entry) => entry !== ask),
        );
    }
    const answered = readList(ANSWERED_KEY);
    if (!answered.includes(ask)) write(ANSWERED_KEY, [...answered, ask]);
}

export function isIntakeComplete(): boolean {
    const settled = new Set([...readList(ANSWERED_KEY), ...declinedAsks()]);
    return QUICK_REPLY_KEYS.filter(isDeclinable).every((ask) =>
        settled.has(ask),
    );
}

export function clearAskLedger(): void {
    safeLocalRemove(KEY);
    safeLocalRemove(ANSWERED_KEY);
}
